import { QueryKey } from '@/application/queryKeys';
import useInfrastructure from '@/application/useInfrastructure';
import { useNftx } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { Address } from 'nftx.js';

const usePoolCurrentTick = (poolId: Address | undefined) => {
  const { network, provider } = useNftx();
  const {
    pools: { fetchPoolCurrentTick },
  } = useInfrastructure();

  return useQuery(
    [QueryKey.POOL_CURRENT_TICK, poolId, network],
    async () => {
      if (!poolId) {
        throw new Error('Pool ID is required');
      }

      return fetchPoolCurrentTick({ network, poolId, provider });
    },
    { enabled: !!poolId, staleTime: 15000 }
  );
};

export default usePoolCurrentTick;
